<template>
  <!-- 申请记录 -->
  <div class="applyRecord">
    <commonTable
      :headList="headList"
      :dataList="dataList"
      :background="true"
      @currentChange="currentChange"
      :total="total"
      :currentPage="currentPage"
    />
  </div>
</template>

<script>
import { fillApplyList } from "../../utils/interface";
import commonTable from "../../components/commonTable.vue";
export default {
  name: "",
  components: { commonTable },
  props: {},
  data() {
    return {
      headList: [
        { label: "填报原因", value: "reason" },
        { label: "申请日期", value: "createDate" },
        { label: "审核状态", value: "status", type: "ifPass" }
      ],
      dataList: [],
      currentPage: 1,
      total: 0
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.query();
  },
  methods: {
    query() {
      fillApplyList({
        userId: this.$store.state.isUsermessage.uuid,
        current: this.currentPage,
        pageSize: 10
      }).then(res => {
        if (res.list && res.list.length > 0) {
          this.dataList = res.list;
          this.total = res.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    currentChange(Page) {
      this.currentPage = Page.currentPage;
      this.query();
    }
  }
};
</script>
<style lang="less" scoped></style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/applyRecord.vue